import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"

import styles from "./index.less"

let DescriptionSpinner = (props) => {
  let { message } = props

  return (
    <div className={styles.spinnerBox}>
      <Icon icon="fa-spinner" className={classnames(styles.spinnerIcon, "fa-spin")} />
      {message}
    </div>
  )
}

DescriptionSpinner.propTypes = {
  message: PropTypes.string,
}

export default DescriptionSpinner
